import React from "react";
import { Box } from "@mui/material";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import { AccountsandFinanceurl } from "../../../../config";
import SuspendedSmsTransactionForm from "./form";

const base_url = AccountsandFinanceurl.uri;

const SuspendedSms = () => {
  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    isSubright: true,
    edit: {
      key: "EDIT",
      button_name: "Reconcile Transaction",
      Show_Button: true,
      permission: "hasNoPermission",
    roleGroupId: [1],
    },
    dataObject: {
      ignoreFields: [
        "Reconcilleddate",
        "UpdateDate",
        "Createdby",
        "IsActive",
        "InvoiceNumber",
        "MSISDN",
        "Transtype",
        "Company",
        "Verified",
        "Createddate",
        "IsReconcilled",
        "Messagearrivaltime",
        "Loanref",
        "MiddleName",
        "OrgAccountBalance",
      ],
      objectName: "suspendedSmsTxnsByCompanyId",
      parameters: null,
      inputObjectName: null,
    },
    showMore: {
      objectname: "suspendedTxnsSmsByColumnValues",
      inputsubobjectname: "suspendedTrns",
      parameters: "transName",
      search: true,
      baseUrl: base_url,
      title: "Suspended Transactions By TransName",
    },
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Suspended (SMS) Transactions"
        subtitle="Manage Suspended (SMS) Transactions"
        FormComponent={SuspendedSmsTransactionForm}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default SuspendedSms;
